/**
 *
 * Asynchronously loads the component for ErrorBoundary
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
